// TvProducao – Dashboard de Produção (reescrito)
import React, { useEffect, useState, useCallback, useRef } from 'react';
import api from '../../../services/api';
import { useUser } from '../../../contexts/userContext';
import './style.css';

// Opções de campos disponíveis para configuração
const DATE_FIELD_OPTIONS = [
  { value: 'previsao_producao',      label: 'Previsão Produção' },
  { value: 'previsao_medicao',       label: 'Previsão Medição' },
  { value: 'previsao_entrega_vidro', label: 'Previsão Entrega Vidro' },
  { value: 'previsao_vistoria_pre',  label: 'Previsão Vistoria Pré' },
  { value: 'previsao_entrega_obra',  label: 'Previsão Entrega Obra' },
  { value: 'previsao_instalacao',    label: 'Previsão Instalação' },
  { value: 'previsao_vistoria_pos',  label: 'Previsão Vistoria Pós' },
  { value: 'previsao_assistencia',   label: 'Previsão Assistência' },
];

const STATUS_FIELD_OPTIONS = [
  { value: 'status_producao',      label: 'Status Produção' },
  { value: 'status_medicao',       label: 'Status Medição' },
  { value: 'status_entrega_vidro', label: 'Status Entrega Vidro' },
  { value: 'status_vistoria_pre',  label: 'Status Vistoria Pré' },
  { value: 'status_entrega_obra',  label: 'Status Entrega Obra' },
  { value: 'status_instalacao',    label: 'Status Instalação' },
  { value: 'status_vistoria_pos',  label: 'Status Vistoria Pós' },
  { value: 'status_assistencia',   label: 'Status Assistência' },
];

const STATUS_VALUE_OPTIONS = [
  { value: 'EmAndamento', label: 'Em Andamento' },
  { value: 'Pronto',      label: 'Pronto' },
  { value: 'Parado',      label: 'Parado' },
  { value: 'Parcial',     label: 'Parcial' },
];

const REFRESH_SECONDS = 60;

const fmtCurrency = (v) =>
  Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const fmtNum = (v, dec = 0) =>
  Number(v).toFixed(dec).replace('.', ',');

const toISO = (d) => {
  const y  = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${mo}-${dd}`;
};

const getWeekBounds = () => {
  const today = new Date();
  const dow   = today.getDay();
  const start = new Date(today);
  start.setDate(today.getDate() - (dow === 0 ? 6 : dow - 1));
  const end = new Date(start);
  end.setDate(start.getDate() + 6);
  return { start: toISO(start), end: toISO(end) };
};

const fmtTime = (d) =>
  [d.getHours(), d.getMinutes(), d.getSeconds()]
    .map(n => String(n).padStart(2, '0'))
    .join(':');

const fmtDate = (d) =>
  [String(d.getDate()).padStart(2, '0'),
   String(d.getMonth() + 1).padStart(2, '0'),
   d.getFullYear()].join('/');

// Formata data a partir de string YYYY-MM-DD sem depender de new Date() (evita bug de timezone)
const fmtDateStr = (s) => {
  if (!s) return '—';
  const p = String(s).substring(0, 10).split('-');
  if (p.length < 3) return '—';
  return `${p[2]}/${p[1]}/${p[0]}`;
};

// ─── HorasMetricsSection ─────────────────────────────────────────────────────


const reorderList = (list, startIndex, endIndex) => {
  const next = Array.from(list);
  const [removed] = next.splice(startIndex, 1);
  next.splice(endIndex, 0, removed);
  return next;
};

function ReorderableCard({ cfg, group, enabled, draggingId, dragOverId, onDragStart, onDragOver, onDrop, onDragEnd, children }) {
  const canDrag = enabled && cfg?.id;
  const cardId = cfg?.id ? String(cfg.id) : '';
  const isDragging = draggingId === cardId;
  const isDragOver = dragOverId === `${group}:${cardId}`;

  return (
    <div
      className={`tvp-reorder-tile${canDrag ? ' tvp-reorder-tile--enabled' : ''}${isDragging ? ' tvp-reorder-tile--dragging' : ''}${isDragOver ? ' tvp-reorder-tile--over' : ''}`}
      draggable={canDrag}
      onDragStart={canDrag ? (e) => onDragStart(e, group, cfg) : undefined}
      onDragOver={canDrag ? (e) => onDragOver(e, group, cfg) : undefined}
      onDrop={canDrag ? (e) => onDrop(e, group, cfg) : undefined}
      onDragEnd={canDrag ? onDragEnd : undefined}
    >
      {children}
      {canDrag && <span className="tvp-reorder-handle" title="Arrastar para reordenar">::</span>}
    </div>
  );
}

function HorasMetricCard({ label, sub, value, extras, icon, color, accent, hideValues, onConfigure, cfg, onClick, configMode }) {
  const isMoney = cfg?.displayFormat === 'currency';
  const mv = v => (hideValues && isMoney) ? '•••••' : v;
  const mvMoney = v => hideValues ? '•••••' : v;
  return (
    <div className={`tvp-hm-card${accent ? ' tvp-hm-card--accent' : ''}`} style={{ '--tvp-hm-color': color, cursor: configMode ? 'grab' : 'pointer' }} onClick={configMode ? undefined : onClick}>
      <div className="tvp-hm-top">
        <span className="tvp-hm-icon">{icon}</span>
        <span className="tvp-hm-label">{label}</span>
      </div>
      <span className="tvp-hm-value">{mv(value)}</span>
      {extras && (
        <div className="tvp-hm-extras">
          <div className="tvp-hm-extra-row"><span className="tvp-hm-extra-label">Horas</span><span className="tvp-hm-extra-val">{fmtNum(extras.horas)} h</span></div>
          <div className="tvp-hm-extra-row"><span className="tvp-hm-extra-label">Valor</span><span className="tvp-hm-extra-val">{mvMoney(fmtCurrency(extras.valor))}</span></div>
          <div className="tvp-hm-extra-row"><span className="tvp-hm-extra-label">Etapa</span><span className="tvp-hm-extra-val">{mvMoney(fmtCurrency(extras.valorEtapa))}</span></div>
        </div>
      )}
      <span className="tvp-hm-sub">{sub}</span>
      {onConfigure && (
        <button className="tvp-ctrl-cfg-btn tvp-hm-cfg-btn" onClick={(e) => { e.stopPropagation(); onConfigure(cfg); }} title="Configurar card">⚙️</button>
      )}
    </div>
  );
}

function HorasMetricsSection({ metrics, horasCards, configMode, onConfigure, onCardClick, hideValues, renderReorderableCard }) {
  const comPeriodo = horasCards.filter(c => c.usePeriodFilter);
  const semPeriodo = horasCards.filter(c => !c.usePeriodFilter);

  const renderCard = (cfg, group) => {
    const rawObj = metrics[cfg.key];
    const isObj = rawObj && typeof rawObj === 'object' && 'value' in rawObj;
    const raw = isObj ? rawObj.value : rawObj;
    const fmt = cfg.displayFormat;
    let display;
    if (fmt === 'date')          display = fmtDateStr(raw);
    else if (fmt === 'currency') display = fmtCurrency(raw || 0);
    else if (fmt === 'decimal')  display = `${fmtNum(raw || 0, 1)} m²`;
    else if (fmt === 'hours')    display = `${fmtNum(raw || 0)} h`;
    else                         display = fmtNum(raw || 0);
    const extras = isObj ? { horas: rawObj.horas, valor: rawObj.valor, valorEtapa: rawObj.valorEtapa } : null;
    const card = (
      <HorasMetricCard
        label={cfg.label}
        sub={cfg.subText || ''}
        value={display}
        extras={extras}
        icon={cfg.emoji}
        color={cfg.color}
        accent={cfg.accent}
        hideValues={hideValues}
        onConfigure={configMode ? onConfigure : null}
        cfg={cfg}
        onClick={() => onCardClick(cfg)}
        configMode={configMode}
      />
    );
    return renderReorderableCard ? renderReorderableCard(group, cfg, card) : React.cloneElement(card, { key: cfg.key });
  };

  return (
    <>
      {comPeriodo.length > 0 && (
        <section className="tvp-horas-section">
          <div className="tvp-horas-header">
            <span className="tvp-horas-header-title">⚙️ Métricas de Horas — Período</span>
            <span className="tvp-horas-header-sub">Filtros aplicados automaticamente por categoria · período selecionado</span>
          </div>
          <div className="tvp-horas-grid">
            {comPeriodo.map(cfg => renderCard(cfg, 'horas-periodo'))}
          </div>
        </section>
      )}
      {semPeriodo.length > 0 && (
        <section className="tvp-horas-section">
          <div className="tvp-horas-header">
            <span className="tvp-horas-header-title">📊 Métricas Carteira — Total</span>
            <span className="tvp-horas-header-sub">Valores totais da carteira · sem filtro de período</span>
          </div>
          <div className="tvp-horas-grid">
            {semPeriodo.map(cfg => renderCard(cfg, 'horas-total'))}
          </div>
        </section>
      )}
    </>
  );
}

// ─── SummaryBanner ───────────────────────────────────────────────────────────
function SumItem({ icon, label, value, color, comparison, onConfigure, cfg }) {
  return (
    <div className="tvp-sum-item" style={{ '--tvp-sum-color': color }}>
      <div className="tvp-sum-top">
        <span className="tvp-sum-icon">{icon}</span>
        <span className="tvp-sum-value">{value}</span>
      </div>
      <span className="tvp-sum-label">{label}</span>
      {comparison && (
        <span className={`tvp-sum-comparison ${comparison.startsWith('+') ? 'tvp-sum-up' : comparison.startsWith('-') ? 'tvp-sum-down' : ''}`}>
          {comparison} vs. ano ant.
        </span>
      )}
      {onConfigure && (
        <button className="tvp-ctrl-cfg-btn tvp-sum-cfg-btn" onClick={(e) => { e.stopPropagation(); onConfigure(cfg); }} title="Configurar card">⚙️</button>
      )}
    </div>
  );
}

const MONEY_LABELS = new Set(['Valor Total', 'Valor Etapa']);



function pctChange(current, previous) {
  if (!previous || previous === 0) return current > 0 ? '+100%' : '—';
  const pct = ((current - previous) / previous * 100).toFixed(1);
  return pct > 0 ? `+${pct}%` : `${pct}%`;
}

function SummaryBanner({ summary, totalCards, hideValues, ytd, summaryCards, configMode, onConfigure, renderReorderableCard }) {
  const cards = summaryCards;
  const prev = ytd?.previous || {};
  const curr = ytd?.current  || {};
  const yearPrev = ytd?.yearPrevious || '';

  const comp = (currVal, prevVal) => {
    if (!yearPrev) return null;
    return pctChange(currVal, prevVal);
  };

  // Mapeamento de metricKey → valor computado
  const metricValues = {
    totalCards:      totalCards,
    totalHoras:      summary.totalHoras      || 0,
    totalQuadros:    summary.totalQuadros    || 0,
    totalEsquadrias: summary.totalEsquadrias || 0,
    totalM2:         summary.totalM2         || 0,
    totalValor:      summary.totalValor      || 0,
    totalValorEtapa: summary.totalValorEtapa || 0,
    maiorData:       summary.maiorData       || null,
  };

  const formatVal = (metricKey, fmt) => {
    const raw = metricValues[metricKey];
    if (fmt === 'currency') return fmtCurrency(raw || 0);
    if (fmt === 'decimal')  return fmtNum(raw || 0, 1);
    if (fmt === 'date')     return fmtDateStr(raw);
    return String(raw ?? 0);
  };

  const mask = (label, val) => (hideValues && MONEY_LABELS.has(label)) ? '•••••' : val;

  return (
    <div className="tvp-summary-banner">
      {cards.map(cfg => {
        const val = formatVal(cfg.metricKey, cfg.displayFormat);
        const isMoney = MONEY_LABELS.has(cfg.label);
        const displayed = mask(cfg.label, val);
        const ytdComp = cfg.showYtd && !(hideValues && isMoney)
          ? comp(curr[cfg.metricKey], prev[cfg.metricKey])
          : null;
        const item = (
          <SumItem
            icon={cfg.emoji}
            label={cfg.label}
            value={displayed}
            color={cfg.color}
            comparison={ytdComp}
            onConfigure={configMode ? onConfigure : null}
            cfg={cfg}
          />
        );
        return renderReorderableCard ? renderReorderableCard('summary', cfg, item) : React.cloneElement(item, { key: cfg.key });
      })}
    </div>
  );
}

// ─── CircleTimer ──────────────────────────────────────────────────────────────
function CircleTimer({ seconds, total }) {
  const r     = 22;
  const circ  = 2 * Math.PI * r;
  const dash  = (seconds / total) * circ;

  return (
    <div className="tvp-timer-wrap" title={`Atualiza em ${seconds}s`}>
      <svg className="tvp-timer-svg" viewBox="0 0 54 54">
        <circle className="tvp-timer-track" cx="27" cy="27" r={r} />
        <circle
          className="tvp-timer-prog"
          cx="27" cy="27" r={r}
          strokeDasharray={`${dash} ${circ}`}
          style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%' }}
        />
      </svg>
      <span className="tvp-timer-text">{seconds}s</span>
    </div>
  );
}

// ─── Stat ─────────────────────────────────────────────────────────────────────
function Stat({ label, value }) {
  return (
    <div className="tvp-stat">
      <span className="tvp-stat-value">{value}</span>
      <span className="tvp-stat-label">{label}</span>
    </div>
  );
}

// ─── ControleCard ─────────────────────────────────────────────────────────────
function ControleCard({ cfg, agg, hideValues, onConfigure, onClick, configMode }) {
  const count         = agg.count         || 0;
  const totalHoras    = agg.totalHoras     || 0;
  const totalEsq      = agg.totalEsquadrias|| 0;
  const totalQuadros  = agg.totalQuadros   || 0;
  const totalM2       = agg.totalM2        || 0;
  const totalValor    = agg.totalValor     || 0;
  const totalVE       = agg.totalValorEtapa|| 0;
  const weeksBetween  = agg.weeksBetween   || 0;
  const hasData       = count > 0;
  const mv = v => hideValues ? '•••••' : v;

  return (
    <div className="tvp-ctrl-card" style={{ '--tvp-ctrl-color': cfg.color, cursor: configMode ? 'grab' : 'pointer' }} onClick={configMode ? undefined : onClick}>
      {/* Header */}
      <div className="tvp-ctrl-head" style={{ background: cfg.gradient }}>
        <span className="tvp-ctrl-emoji">{cfg.emoji}</span>
        <div className="tvp-ctrl-title-block">
          <span className="tvp-ctrl-name">{cfg.label}</span>
          <span className="tvp-ctrl-badge">{count} pedido{count !== 1 ? 's' : ''}</span>
        </div>
        <div className="tvp-ctrl-valor-main">{mv(fmtCurrency(totalVE || totalValor))}</div>
        {onConfigure && (
          <button className="tvp-ctrl-cfg-btn" onClick={(e) => { e.stopPropagation(); onConfigure(cfg); }} title="Configurar card">
            ⚙️
          </button>
        )}
      </div>

      {/* Métricas */}
      <div className="tvp-ctrl-stats">
        <Stat label="Horas"      value={fmtNum(totalHoras)} />
        <Stat label="Esquadrias" value={fmtNum(totalEsq)} />
        <Stat label="Quadros"    value={fmtNum(totalQuadros)} />
        <Stat label="m²"         value={fmtNum(totalM2, 1)} />
      </div>

      {/* Insights */}
      <div className="tvp-ctrl-insights">
        {!hasData ? (
          <div className="tvp-ctrl-empty">Nenhum pedido no período selecionado</div>
        ) : (
          <>
            <div className="tvp-ctrl-date-row">
              <div className="tvp-ctrl-date-box">
                <span className="tvp-ctrl-date-lbl">Primeira previsão</span>
                <span className="tvp-ctrl-date-val">{fmtDateStr(agg.minDate)}</span>
              </div>
              <div className="tvp-ctrl-date-connector">
                <div className="tvp-ctrl-date-line" />
                <span className="tvp-ctrl-weeks-pill">{weeksBetween} sem.</span>
              </div>
              <div className="tvp-ctrl-date-box">
                <span className="tvp-ctrl-date-lbl">Última previsão</span>
                <span className="tvp-ctrl-date-val">{fmtDateStr(agg.maxDate)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ─── DetailModal — lista obras filtradas por card ─────────────────────────────
function DetailModal({ cardCfg, cards, loading, onClose }) {
  const sumValue = (field) => cards.reduce((total, card) => {
    const rawValue = card?.[field];
    if (rawValue === null || rawValue === undefined || rawValue === '') return total;

    if (typeof rawValue === 'number') {
      return Number.isFinite(rawValue) ? total + rawValue : total;
    }

    const textValue = String(rawValue).trim();
    let numericValue = Number(textValue);

    // Aceita tanto o formato retornado pelo banco (1234.56) quanto pt-BR (1.234,56).
    if (!Number.isFinite(numericValue)) {
      numericValue = Number(textValue.replace(/\./g, '').replace(',', '.'));
    }

    return Number.isFinite(numericValue) ? total + numericValue : total;
  }, 0);

  const totals = {
    horas: sumValue('horas_producao'),
    esquadrias: sumValue('quantidade_esquadrias'),
    quadros: sumValue('quantidade_quadros'),
    metrosQuadrados: sumValue('metros_quadrados'),
    valor: sumValue('cost_value'),
  };

  return (
    <div className="tvp-modal-overlay" onClick={onClose}>
      <div className="tvp-detail-modal" onClick={e => e.stopPropagation()}>
        <div className="tvp-modal-header" style={{ background: cardCfg.gradient || cardCfg.color }}>
          <h3>{cardCfg.emoji} {cardCfg.label} — {loading ? '...' : `${cards.length} obra${cards.length !== 1 ? 's' : ''}`}</h3>
          <button className="tvp-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="tvp-detail-body">
          {loading ? (
            <div className="tvp-detail-loading">Carregando...</div>
          ) : cards.length === 0 ? (
            <div className="tvp-detail-empty">Nenhuma obra encontrada para este filtro.</div>
          ) : (
            <>
              <div className="tvp-detail-totals" aria-label="Totais de todas as obras listadas">
                <div className="tvp-detail-total-item">
                  <span>Obras</span>
                  <strong>{fmtNum(cards.length)}</strong>
                </div>
                <div className="tvp-detail-total-item">
                  <span>Horas</span>
                  <strong>{fmtNum(totals.horas)} h</strong>
                </div>
                <div className="tvp-detail-total-item">
                  <span>Esquadrias</span>
                  <strong>{fmtNum(totals.esquadrias)}</strong>
                </div>
                <div className="tvp-detail-total-item">
                  <span>Quadros</span>
                  <strong>{fmtNum(totals.quadros)}</strong>
                </div>
                <div className="tvp-detail-total-item">
                  <span>Área</span>
                  <strong>{fmtNum(totals.metrosQuadrados, 1)} m²</strong>
                </div>
                <div className="tvp-detail-total-item tvp-detail-total-item--money">
                  <span>Valor total</span>
                  <strong>{fmtCurrency(totals.valor)}</strong>
                </div>
              </div>
              <div className="tvp-detail-table-scroll">
                <table className="tvp-detail-table">
                  <thead>
                    <tr>
                      <th>Pedido</th>
                      <th>Obra</th>
                      <th>Produto</th>
                      <th>Horas</th>
                      <th>Esq.</th>
                      <th>Quadros</th>
                      <th>m²</th>
                      <th>Valor</th>
                      <th>Previsão Prod.</th>
                      <th>Status Prod.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cards.map((c, i) => (
                      <tr key={c.card_id || i}>
                        <td>{c.pedido_number || '—'}</td>
                        <td>{c.name || '—'}</td>
                        <td>{c.produto || '—'}</td>
                        <td>{fmtNum(c.horas_producao || 0)}</td>
                        <td>{fmtNum(c.quantidade_esquadrias || 0)}</td>
                        <td>{fmtNum(c.quantidade_quadros || 0)}</td>
                        <td>{fmtNum(c.metros_quadrados || 0, 1)}</td>
                        <td>{fmtCurrency(c.cost_value || 0)}</td>
                        <td>{fmtDateStr(c.previsao_producao)}</td>
                        <td>{c.status_producao || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3">TOTAL — {cards.length} obra{cards.length !== 1 ? 's' : ''}</td>
                      <td>{fmtNum(totals.horas)}</td>
                      <td>{fmtNum(totals.esquadrias)}</td>
                      <td>{fmtNum(totals.quadros)}</td>
                      <td>{fmtNum(totals.metrosQuadrados, 1)}</td>
                      <td>{fmtCurrency(totals.valor)}</td>
                      <td colSpan="2">—</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── CardConfigModal ──────────────────────────────────────────────────────────
const CARD_TYPE_OPTIONS = [
  { value: 'controle', label: 'Controle (grid)' },
  { value: 'horas',    label: 'Métrica de Horas' },
  { value: 'summary',  label: 'Sumário (banner)' },
];

const AGGREGATION_OPTIONS = [
  { value: 'standard',        label: 'Padrão (controle)' },
  { value: 'sum_horas',       label: 'Soma de Horas' },
  { value: 'count',           label: 'Contagem de Obras' },
  { value: 'sum_quadros',     label: 'Soma de Quadros' },
  { value: 'sum_esquadrias',  label: 'Soma de Esquadrias' },
  { value: 'sum_m2',          label: 'Soma de m²' },
  { value: 'sum_valor',       label: 'Soma de Valor (cost_value)' },
  { value: 'sum_valor_etapa', label: 'Soma de Valor Etapa' },
  { value: 'max_date',        label: 'Data Máxima (campo único)' },
  { value: 'max_date_all',    label: 'Data Máxima (todos os campos)' },
];

const DISPLAY_FORMAT_OPTIONS = [
  { value: 'number',   label: 'Número inteiro' },
  { value: 'decimal',  label: 'Decimal (1 casa)' },
  { value: 'currency', label: 'Moeda (R$)' },
  { value: 'hours',    label: 'Horas' },
  { value: 'date',     label: 'Data' },
];

const METRIC_KEY_OPTIONS = [
  { value: 'totalCards',      label: 'Total Obras' },
  { value: 'totalHoras',      label: 'Total Horas' },
  { value: 'totalQuadros',    label: 'Total Quadros' },
  { value: 'totalEsquadrias', label: 'Total Esquadrias' },
  { value: 'totalM2',         label: 'Total m²' },
  { value: 'totalValor',      label: 'Valor Total' },
  { value: 'totalValorEtapa', label: 'Valor Etapa' },
  { value: 'maiorData',       label: 'Última Data' },
];

function CardConfigModal({ card, onClose, onSave, onDelete, isNew }) {
  const cardType = card?.cardType || 'controle';
  const [form, setForm] = useState({
    card_type:             isNew ? 'controle' : cardType,
    card_key:              card?.key            || '',
    label:                 card?.label          || '',
    emoji:                 card?.emoji          || '📋',
    color:                 card?.color          || '#3B82F6',
    gradient:              card?.gradient       || 'linear-gradient(135deg,#1d4ed8,#3B82F6)',
    accent:                card?.accent         || '',
    sub_text:              card?.subText        || '',
    date_field:            card?.dateField      || 'previsao_producao',
    status_field:          card?.statusField    || 'status_producao',
    status_values:         card?.statusValues   || ['EmAndamento'],
    use_period_filter:     card?.usePeriodFilter ?? true,
    exclude_produto_regex: card?.excludeProdutoRegex || '',
    state_filter:          card?.stateFilter || '',
    is_overdue_card:       card?.isOverdueCard  || false,
    column_include_pattern:  card?.columnIncludePattern  || '',
    column_exclude_pattern:  card?.columnExcludePattern  || '',
    column_range_start:      card?.columnRangeStart      || '',
    column_range_start_exclude: card?.columnRangeStartExclude || '',
    column_range_end:        card?.columnRangeEnd        || '',
    aggregation:           card?.aggregation    || 'standard',
    display_format:        card?.displayFormat  || 'number',
    metric_key:            card?.metricKey      || 'totalCards',
    show_ytd:              card?.showYtd        || false,
  });
  const [saving, setSaving] = useState(false);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const toggleStatus = (val) => {
    set('status_values',
      form.status_values.includes(val)
        ? form.status_values.filter(v => v !== val)
        : [...form.status_values, val]
    );
  };

  const handleSave = async () => {
    if (!form.card_key || !form.label) return;
    setSaving(true);
    try {
      await onSave({
        ...form,
        id: card?.id || null,
        exclude_produto_regex: form.exclude_produto_regex || null,
        state_filter: form.state_filter || null,
      });
      onClose();
    } catch (err) {
      console.error('Erro ao salvar card:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!card?.id) return;
    if (!window.confirm(`Excluir o card "${form.label}"?`)) return;
    setSaving(true);
    try {
      await onDelete(card.id);
      onClose();
    } catch (err) {
      console.error('Erro ao excluir card:', err);
    } finally {
      setSaving(false);
    }
  };

  const isControle = form.card_type === 'controle';
  const isHoras    = form.card_type === 'horas';
  const isSummary  = form.card_type === 'summary';

  return (
    <div className="tvp-modal-overlay" onClick={onClose}>
      <div className="tvp-modal" onClick={e => e.stopPropagation()}>
        <div className="tvp-modal-header">
          <h3>{isNew ? 'Novo Card' : `Configurar: ${card?.label}`}</h3>
          <button className="tvp-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="tvp-modal-body">
          {/* Tipo + Identidade */}
          <div className="tvp-modal-section">
            <h4>Identidade</h4>
            <div className="tvp-modal-row">
              <label>
                <span>Tipo de Card</span>
                <select value={form.card_type} onChange={e => set('card_type', e.target.value)} disabled={!isNew}>
                  {CARD_TYPE_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </label>
              <label>
                <span>Chave (slug)</span>
                <input value={form.card_key} onChange={e => set('card_key', e.target.value)}
                  disabled={!isNew} placeholder="ex: producao" />
              </label>
            </div>
            <div className="tvp-modal-row">
              <label>
                <span>Rótulo</span>
                <input value={form.label} onChange={e => set('label', e.target.value)}
                  placeholder="ex: Produção" />
              </label>
              <label>
                <span>Emoji</span>
                <input value={form.emoji} onChange={e => set('emoji', e.target.value)}
                  style={{ width: 60, textAlign: 'center' }} />
              </label>
              <label>
                <span>Cor</span>
                <div className="tvp-modal-color-row">
                  <input type="color" value={form.color}
                    onChange={e => set('color', e.target.value)} />
                  <input value={form.color} onChange={e => set('color', e.target.value)}
                    style={{ width: 100 }} />
                </div>
              </label>
            </div>
            {isControle && (
              <div className="tvp-modal-row">
                <label>
                  <span>Gradiente CSS</span>
                  <input value={form.gradient} onChange={e => set('gradient', e.target.value)}
                    placeholder="linear-gradient(135deg, ...)" />
                </label>
              </div>
            )}
            {isHoras && (
              <div className="tvp-modal-row">
                <label>
                  <span>Subtítulo</span>
                  <input value={form.sub_text} onChange={e => set('sub_text', e.target.value)}
                    placeholder="Descrição do filtro aplicado" />
                </label>
                <label>
                  <span>Cor Accent</span>
                  <input value={form.accent} onChange={e => set('accent', e.target.value)}
                    placeholder="#C084FC" style={{ width: 100 }} />
                </label>
              </div>
            )}
          </div>

          {/* Filtros — Controle e Horas */}
          {(isControle || isHoras) && (
            <div className="tvp-modal-section">
              <h4>Filtros de Dados</h4>
              <div className="tvp-modal-row">
                <label>
                  <span>Campo de Data</span>
                  <select value={form.date_field} onChange={e => set('date_field', e.target.value)}>
                    {DATE_FIELD_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
                <label>
                  <span>Campo de Status</span>
                  <select value={form.status_field} onChange={e => set('status_field', e.target.value)}>
                    {STATUS_FIELD_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="tvp-modal-row">
                <label>
                  <span>Valores de Status</span>
                  <div className="tvp-modal-checkbox-group">
                    {STATUS_VALUE_OPTIONS.map(o => (
                      <label key={o.value} className="tvp-modal-checkbox">
                        <input type="checkbox"
                          checked={(form.status_values || []).includes(o.value)}
                          onChange={() => toggleStatus(o.value)} />
                        {o.label}
                      </label>
                    ))}
                  </div>
                </label>
              </div>

              <div className="tvp-modal-row">
                <label className="tvp-modal-toggle">
                  <input type="checkbox" checked={form.use_period_filter}
                    onChange={e => set('use_period_filter', e.target.checked)} />
                  <span>Aplicar filtro de período (datas do cabeçalho)</span>
                </label>
                {isControle && (
                  <label className="tvp-modal-toggle">
                    <input type="checkbox" checked={form.is_overdue_card}
                      onChange={e => set('is_overdue_card', e.target.checked)} />
                    <span>Card de atraso (previsão &lt; hoje e status ≠ Pronto)</span>
                  </label>
                )}
              </div>

              <div className="tvp-modal-row">
                <label>
                  <span>Excluir produtos (regex)</span>
                  <input value={form.exclude_produto_regex}
                    onChange={e => set('exclude_produto_regex', e.target.value)}
                    placeholder="Deixe vazio para não filtrar" />
                </label>
                <label>
                  <span>Estado</span>
                  <input value={form.state_filter}
                    onChange={e => set('state_filter', e.target.value)}
                    placeholder="ex: RIO GRANDE DO SUL ou RS" />
                </label>
              </div>
            </div>
          )}

          {/* Filtros de Colunas — Horas e Controle */}
          {(isHoras || isControle) && (
            <div className="tvp-modal-section">
              <h4>Filtro de Colunas de Processo</h4>
              <div className="tvp-modal-row">
                <label>
                  <span>Incluir colunas (regex)</span>
                  <input value={form.column_include_pattern}
                    onChange={e => set('column_include_pattern', e.target.value)}
                    placeholder="ex: projeto|corte|solda" />
                </label>
                <label>
                  <span>Excluir colunas (regex)</span>
                  <input value={form.column_exclude_pattern}
                    onChange={e => set('column_exclude_pattern', e.target.value)}
                    placeholder="ex: cancelad|duplicid" />
                </label>
              </div>
              <div className="tvp-modal-row">
                <label>
                  <span>Range início (regex)</span>
                  <input value={form.column_range_start}
                    onChange={e => set('column_range_start', e.target.value)}
                    placeholder="ex: assina" />
                </label>
                <label>
                  <span>Excluir do início (regex)</span>
                  <input value={form.column_range_start_exclude}
                    onChange={e => set('column_range_start_exclude', e.target.value)}
                    placeholder="ex: aguard" />
                </label>
                <label>
                  <span>Range fim (regex)</span>
                  <input value={form.column_range_end}
                    onChange={e => set('column_range_end', e.target.value)}
                    placeholder="ex: qualid" />
                </label>
              </div>
              <div className="tvp-modal-row">
                <label>
                  <span>Agregação</span>
                  <select value={form.aggregation} onChange={e => set('aggregation', e.target.value)}>
                    {AGGREGATION_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
                <label>
                  <span>Formato de exibição</span>
                  <select value={form.display_format} onChange={e => set('display_format', e.target.value)}>
                    {DISPLAY_FORMAT_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          )}

          {/* Configuração — Summary */}
          {isSummary && (
            <div className="tvp-modal-section">
              <h4>Configuração do Sumário</h4>
              <div className="tvp-modal-row">
                <label>
                  <span>Métrica</span>
                  <select value={form.metric_key} onChange={e => set('metric_key', e.target.value)}>
                    {METRIC_KEY_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
                <label>
                  <span>Formato de exibição</span>
                  <select value={form.display_format} onChange={e => set('display_format', e.target.value)}>
                    {DISPLAY_FORMAT_OPTIONS.map(o => (
                      <option key={o.value} value={o.value}>{o.label}</option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="tvp-modal-row">
                <label className="tvp-modal-toggle">
                  <input type="checkbox" checked={form.show_ytd}
                    onChange={e => set('show_ytd', e.target.checked)} />
                  <span>Mostrar comparativo YTD (ano atual vs. anterior)</span>
                </label>
              </div>
            </div>
          )}

          {/* Preview */}
          <div className="tvp-modal-section">
            <h4>Preview</h4>
            <div className="tvp-modal-preview" style={{
              background: isControle ? form.gradient : form.color,
              color: '#fff', padding: '12px 16px', borderRadius: 8,
              display: 'flex', alignItems: 'center', gap: 10
            }}>
              <span style={{ fontSize: 24 }}>{form.emoji}</span>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{form.label || 'Nome do Card'}</div>
                <div style={{ fontSize: 11, opacity: 0.8 }}>
                  {form.card_type === 'summary'
                    ? METRIC_KEY_OPTIONS.find(o => o.value === form.metric_key)?.label || form.metric_key
                    : `${(form.status_values || []).join(', ')} • ${DATE_FIELD_OPTIONS.find(o => o.value === form.date_field)?.label || form.date_field}`
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tvp-modal-footer">
          {!isNew && (
            <button className="tvp-modal-btn tvp-modal-btn--danger" onClick={handleDelete} disabled={saving || !card?.id}>
              Excluir
            </button>
          )}
          <div style={{ flex: 1 }} />
          <button className="tvp-modal-btn tvp-modal-btn--secondary" onClick={onClose}>Cancelar</button>
          <button className="tvp-modal-btn tvp-modal-btn--primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Salvando...' : isNew ? 'Criar' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────
function DashboardProducao() {
  const { user } = useUser();
  const week = getWeekBounds();

  const [startDate,  setStartDate]  = useState(week.start);
  const [endDate,    setEndDate]    = useState(week.end);
  const [dashData,   setDashData]   = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(null);
  const [timer,      setTimer]      = useState(REFRESH_SECONDS);
  const [now,        setNow]        = useState(new Date());
  const [configCard, setConfigCard] = useState(null);   // card aberto no modal (ou '__new__')
  const [configMode, setConfigMode] = useState(false);  // modo admin (gear visível)
  const [hideValues, setHideValues] = useState(false);
  const [detailCard, setDetailCard] = useState(null);   // card aberto no modal de detalhe
  const [detailCards, setDetailCards] = useState([]);    // lista de obras do detalhe
  const [detailLoading, setDetailLoading] = useState(false);
  const [draggingCardId, setDraggingCardId] = useState(null);
  const [draggingGroup, setDraggingGroup] = useState(null);
  const [dragOverCardId, setDragOverCardId] = useState(null);
  const [savingOrder, setSavingOrder] = useState(false);

  const autoRefreshRef = useRef(null);
  const countdownRef   = useRef(null);
  const startDateRef   = useRef(startDate);
  const endDateRef     = useRef(endDate);

  useEffect(() => { startDateRef.current = startDate; }, [startDate]);
  useEffect(() => { endDateRef.current   = endDate;   }, [endDate]);

  // Relógio
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // Busca única ao endpoint dedicado — agrega tudo no servidor
  const fetchAll = useCallback(async () => {
    if (!user?.id || !user?.empresa_id) return;
    setLoading(true);
    try {
      const { data } = await api.get(
        `/card/tv-dashboard/${user.id}/${user.empresa_id}`,
        {
          params: { startDate: startDateRef.current, endDate: endDateRef.current },
          timeout: 30000,
        }
      );
      setDashData(data);
      setLastUpdate(new Date());
      setTimer(REFRESH_SECONDS);
      setFetchError(false);
    } catch (err) {
      console.error('Dashboard TV – erro ao buscar dados:', err);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  }, [user]);

  // Carga inicial
  useEffect(() => { fetchAll(); }, [fetchAll]);

  // Auto-refresh (pausa quando modal está aberto)
  useEffect(() => {
    if (autoRefreshRef.current) clearInterval(autoRefreshRef.current);
    if (countdownRef.current)   clearInterval(countdownRef.current);

    if (!configCard) {
      autoRefreshRef.current = setInterval(fetchAll, REFRESH_SECONDS * 1000);
      countdownRef.current   = setInterval(
        () => setTimer(prev => (prev <= 1 ? REFRESH_SECONDS : prev - 1)),
        1000
      );
    }

    return () => {
      clearInterval(autoRefreshRef.current);
      clearInterval(countdownRef.current);
    };
  }, [fetchAll, configCard]);

  const handleApply = () => fetchAll();

  // Derivar dados pré-agregados do servidor
  const controles    = dashData?.controles    || {};
  const horasMetrics = dashData?.horasMetrics || {};
  const summary      = dashData?.summary      || {};
  const ytdComparison = dashData?.ytdComparison || null;

  // Handler para abrir detalhe de um card
  const handleOpenDetail = useCallback(async (cfg) => {
    if (!user?.id || !user?.empresa_id) return;
    setDetailCard(cfg);
    setDetailCards([]);
    setDetailLoading(true);
    try {
      const { data } = await api.get(
        `/card/tv-dashboard-detail/${user.id}/${user.empresa_id}/${cfg.key}`,
        { params: { startDate: startDateRef.current, endDate: endDateRef.current }, timeout: 30000 }
      );
      setDetailCards(data.cards || []);
    } catch (err) {
      console.error('Erro ao buscar detalhe do card:', err);
      setDetailCards([]);
    } finally {
      setDetailLoading(false);
    }
  }, [user]);

  // Agrupar cardConfigs por tipo
  const allCardConfigs = dashData?.cardConfigs || [];
  const summaryCards  = allCardConfigs.filter(c => c.cardType === 'summary').sort((a, b) => a.displayOrder - b.displayOrder);
  const horasCards    = allCardConfigs.filter(c => c.cardType === 'horas').sort((a, b) => a.displayOrder - b.displayOrder);
  const controleCards = allCardConfigs.filter(c => c.cardType === 'controle' || !c.cardType).sort((a, b) => a.displayOrder - b.displayOrder);
  const horasPeriodoCards = horasCards.filter(c => c.usePeriodFilter);
  const horasTotalCards = horasCards.filter(c => !c.usePeriodFilter);

  const cardConfigs = controleCards;

  const summaryForBanner = {
    maiorData:         summary.maiorData ? summary.maiorData : null,
    totalSemanas:      summary.totalSemanas      || 0,
    semanasAteMaxData: summary.semanasAteMaxData || 0,
    totalHoras:        summary.totalHoras        || 0,
    totalEsquadrias:   summary.totalEsquadrias   || 0,
    totalQuadros:      summary.totalQuadros      || 0,
    totalM2:           summary.totalM2           || 0,
    totalValor:        summary.totalValor        || 0,
    totalValorEtapa:   summary.totalValorEtapa   || 0,
  };

  const getCardsByReorderGroup = (group) => {
    if (group === 'summary') return summaryCards;
    if (group === 'horas-periodo') return horasPeriodoCards;
    if (group === 'horas-total') return horasTotalCards;
    if (group === 'controle') return cardConfigs;
    return [];
  };

  const persistCardOrder = async (orderedCards) => {
    const empresaId = user?.empresa_id;
    const orderedIds = orderedCards.map(c => c.id).filter(Boolean);
    if (!empresaId || orderedIds.length < 2 || !dashData?.cardConfigs) return;

    const previousConfigs = dashData.cardConfigs;
    const baseOrder = Math.min(...orderedCards.map(c => Number(c.displayOrder) || 0));
    const orderById = new Map(orderedIds.map((id, index) => [Number(id), baseOrder + index]));

    setSavingOrder(true);
    setDashData(prev => {
      if (!prev?.cardConfigs) return prev;
      return {
        ...prev,
        cardConfigs: prev.cardConfigs.map(cfg => (
          orderById.has(Number(cfg.id))
            ? { ...cfg, displayOrder: orderById.get(Number(cfg.id)) }
            : cfg
        )),
      };
    });

    try {
      await api.put(`/card/tv-dashboard-cards-reorder/${empresaId}`, { orderedIds });
    } catch (err) {
      console.error('Erro ao reordenar cards do dashboard:', err);
      setDashData(prev => prev ? { ...prev, cardConfigs: previousConfigs } : prev);
      alert('NÃ£o foi possÃ­vel salvar a nova ordem dos cards. Tente novamente.');
    } finally {
      setSavingOrder(false);
    }
  };

  const handleCardDragStart = (event, group, cfg) => {
    if (!configMode || savingOrder || !cfg?.id) {
      event.preventDefault();
      return;
    }
    const payload = JSON.stringify({ group, id: cfg.id });
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('application/json', payload);
    event.dataTransfer.setData('text/plain', payload);
    setDraggingCardId(String(cfg.id));
    setDraggingGroup(group);
  };

  const handleCardDragOver = (event, group, cfg) => {
    if (!draggingCardId || draggingGroup !== group || String(cfg?.id) === draggingCardId) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    setDragOverCardId(`${group}:${cfg.id}`);
  };

  const handleCardDrop = async (event, group, targetCfg) => {
    event.preventDefault();
    setDragOverCardId(null);

    let payload = null;
    try {
      payload = JSON.parse(event.dataTransfer.getData('application/json') || event.dataTransfer.getData('text/plain') || '{}');
    } catch (err) {
      payload = null;
    }

    const sourceGroup = payload?.group || draggingGroup;
    const sourceId = String(payload?.id || draggingCardId || '');
    const targetId = String(targetCfg?.id || '');
    if (!sourceGroup || sourceGroup !== group || !sourceId || !targetId || sourceId === targetId) return;

    const groupCards = getCardsByReorderGroup(group);
    const sourceIndex = groupCards.findIndex(c => String(c.id) === sourceId);
    const targetIndex = groupCards.findIndex(c => String(c.id) === targetId);
    if (sourceIndex < 0 || targetIndex < 0) return;

    const orderedCards = reorderList(groupCards, sourceIndex, targetIndex);
    await persistCardOrder(orderedCards);
    setDraggingCardId(null);
    setDraggingGroup(null);
  };

  const handleCardDragEnd = () => {
    setDraggingCardId(null);
    setDraggingGroup(null);
    setDragOverCardId(null);
  };

  const renderReorderableCard = (group, cfg, card) => (
    <ReorderableCard
      key={cfg.id || cfg.key}
      cfg={cfg}
      group={group}
      enabled={configMode && !savingOrder}
      draggingId={draggingCardId}
      dragOverId={dragOverCardId}
      onDragStart={handleCardDragStart}
      onDragOver={handleCardDragOver}
      onDrop={handleCardDrop}
      onDragEnd={handleCardDragEnd}
    >
      {card}
    </ReorderableCard>
  );

  // CRUD handlers para cards
  const handleSaveCard = async (formData) => {
    const empresaId = user?.empresa_id;
    if (!empresaId) return;

    const payload = {
      empresa_id: empresaId,
      card_type: formData.card_type,
      card_key: formData.card_key,
      label: formData.label,
      emoji: formData.emoji,
      color: formData.color,
      gradient: formData.gradient || null,
      accent: formData.accent || null,
      sub_text: formData.sub_text || null,
      date_field: formData.date_field || null,
      status_field: formData.status_field || null,
      status_values: formData.status_values,
      use_period_filter: formData.use_period_filter,
      exclude_produto_regex: formData.exclude_produto_regex || null,
      state_filter: formData.state_filter || null,
      is_overdue_card: formData.is_overdue_card || false,
      column_include_pattern: formData.column_include_pattern || null,
      column_exclude_pattern: formData.column_exclude_pattern || null,
      column_range_start: formData.column_range_start || null,
      column_range_start_exclude: formData.column_range_start_exclude || null,
      column_range_end: formData.column_range_end || null,
      aggregation: formData.aggregation || 'standard',
      display_format: formData.display_format || 'number',
      metric_key: formData.metric_key || null,
      show_ytd: formData.show_ytd || false,
    };

    try {
      if (formData.id) {
        await api.put(`/card/tv-dashboard-cards/${formData.id}`, payload);
      } else {
        await api.post('/card/tv-dashboard-cards', payload);
      }
      setConfigCard(null);
      fetchAll();
    } catch (err) {
      console.error('Erro ao salvar card:', err);
      alert('Erro ao salvar card. Tente novamente.');
    }
  };

  const handleDeleteCard = async (cardId) => {
    try {
      await api.delete(`/card/tv-dashboard-cards/${cardId}`);
      setConfigCard(null);
      fetchAll();
    } catch (err) {
      console.error('Erro ao excluir card:', err);
      alert('Erro ao excluir card. Tente novamente.');
    }
  };

  return (
    <div className="tvp-root">

      {/* ── MODAL DE CONFIGURAÇÃO ───────────────────────────────────── */}
      {configCard && (
        <CardConfigModal
          card={configCard === '__new__' ? null : configCard}
          isNew={configCard === '__new__'}
          onClose={() => setConfigCard(null)}
          onSave={handleSaveCard}
          onDelete={handleDeleteCard}
        />
      )}

      {/* ── MODAL DE DETALHE ────────────────────────────────────────── */}
      {detailCard && (
        <DetailModal
          cardCfg={detailCard}
          cards={detailCards}
          loading={detailLoading}
          onClose={() => { setDetailCard(null); setDetailCards([]); }}
        />
      )}

      {/* ── HEADER ──────────────────────────────────────────────────── */}
      <header className="tvp-header">
        <div className="tvp-header-brand">
          <span className="tvp-brand-name">SYNCS</span>
          <span className="tvp-brand-sub">Dashboard de Produção</span>
        </div>

        <div className="tvp-header-controls">
          <span className="tvp-period-label">Período</span>
          <div className="tvp-period-row">
            <input
              type="date"
              value={startDate}
              onChange={e => { setStartDate(e.target.value); }}
              className="tvp-date-input"
            />
            <span className="tvp-period-sep">→</span>
            <input
              type="date"
              value={endDate}
              onChange={e => { setEndDate(e.target.value); }}
              className="tvp-date-input"
            />
            <button
              className={`tvp-apply-btn${loading ? ' tvp-apply-btn--loading' : ''}`}
              onClick={handleApply}
              disabled={loading}
            >
              {loading ? <span className="tvp-spinner" /> : 'Aplicar'}
            </button>
            <button
              className="tvp-eye-btn"
              onClick={() => setHideValues(v => !v)}
              title={hideValues ? 'Mostrar valores' : 'Ocultar valores'}
            >
              {hideValues ? '🙈' : '👁️'}
            </button>
            <button
              className={`tvp-eye-btn${configMode ? ' tvp-cfg-active' : ''}`}
              onClick={() => setConfigMode(v => !v)}
              title={configMode ? 'Sair do modo configuração' : 'Modo configuração'}
            >
              ⚙️
            </button>
          </div>
        </div>

        <div className="tvp-header-right">
          <div className="tvp-clock-block">
            <span className="tvp-clock">{fmtTime(now)}</span>
            <span className="tvp-date-text">{fmtDate(now)}</span>
          </div>
          <CircleTimer seconds={timer} total={REFRESH_SECONDS} />
        </div>
      </header>

      {/* ── SUMMARY BANNER ──────────────────────────────────────────── */}
      <SummaryBanner
        summary={summaryForBanner}
        totalCards={summary.totalCards || 0}
        hideValues={hideValues}
        ytd={ytdComparison}
        summaryCards={summaryCards}
        configMode={configMode}
        onConfigure={setConfigCard}
        renderReorderableCard={renderReorderableCard}
      />

      {/* ── ERRO DE CONEXÃO ─────────────────────────────────────────── */}
      {fetchError && (
        <div className="tvp-fetch-error">
          ⚠️ Não foi possível conectar ao servidor. Verifique sua conexão ou se o servidor está ativo.
          <button className="tvp-error-retry" onClick={handleApply}>Tentar novamente</button>
        </div>
      )}

      {/* ── HORAS METRICS ───────────────────────────────────────────── */}
      <HorasMetricsSection
        metrics={horasMetrics}
        horasCards={horasCards}
        configMode={configMode}
        onConfigure={setConfigCard}
        onCardClick={handleOpenDetail}
        hideValues={hideValues}
        renderReorderableCard={renderReorderableCard}
      />

      {/* ── CONTROLES GRID ──────────────────────────────────────────── */}
      <section className="tvp-grid">
        {cardConfigs.map(cfg => renderReorderableCard('controle', cfg, (
          <ControleCard
            cfg={cfg}
            agg={controles[cfg.key] || {}}
            hideValues={hideValues}
            onConfigure={configMode ? setConfigCard : null}
            onClick={() => handleOpenDetail(cfg)}
            configMode={configMode}
          />
        )))}
        {configMode && (
          <button className="tvp-add-card-btn" onClick={() => setConfigCard('__new__')}>
            <span className="tvp-add-card-icon">＋</span>
            <span>Novo Card</span>
          </button>
        )}
      </section>

      {/* ── FOOTER ──────────────────────────────────────────────────── */}
      <footer className="tvp-footer">
        <span className="tvp-footer-brand">SyncsCRM • www.syncscrm.com.br</span>
        {lastUpdate && (
          <span className="tvp-footer-update">
            Atualizado às {fmtTime(lastUpdate)} — próxima atualização em {timer}s
          </span>
        )}
      </footer>
    </div>
  );
}

export default DashboardProducao;
